import {
  HomePageLayoutBlueprint,
} from '@backstage/plugin-home-react/alpha';

import { HomePage } from './components';

export const HomeExtension = HomePageLayoutBlueprint.make({
  params: {
    loader: async () => HomePage,
  },
});
